import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { BasicInfoDataType } from '../../models/profileSettings/basicInformation.model';
import {
  ErrorHttpResponse,
  HttpConfig,
  SuccessHttpResponse,
} from '../../models/https';
// import { useAppSelector } from '../../../../redux/store'
import useHttps from '../useHttps';
import useGetData from '../settings/useGetData';
import { useAppSelector } from '../../redux/store';

const useUpdateBasicInformation = () => {
  // const { authData } = useAppSelector((state) => state.auth);
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const { getUserData } = useGetData();
  const { authData } = useAppSelector((state) => state.auth);

  const onUpdateBasicInfoError = (err: AxiosError<ErrorHttpResponse>) => {
    toast.error(
      err?.response?.data?.message ??
        'Something went wrong while updating basic information'
    );
  };

  const onUpdateBasicInfoSuccess = ({
    data,
    message,
  }: SuccessHttpResponse<any>) => {
    toast.success(message);
    getUserData();
  };

  const updateBasicInfo = (data: BasicInfoDataType) => {
    if (!authData) return;
    const formData = new FormData();

    // Append text fields
    formData.append('institutionName', data.institutionName);
    formData.append('email', data.email);
    formData.append('street', data.street);
    formData.append('facilityType', data.facilityType);
    formData.append('country', data.country);
    formData.append('state', data.state);
    formData.append('bio', data.bio);
    formData.append('localGovernment', data.localGovernment);

    const url: HttpConfig = {
      url: `auth-service/institution/${authData.id}`,
      method: 'put',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };

    request(url, onUpdateBasicInfoSuccess, setLoading, onUpdateBasicInfoError);
  };

  return { updateBasicInfo, loading };
};

export default useUpdateBasicInformation;
